import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

const HiddenPageIndicator = ({hiddenPage}) => (
    hiddenPage ? (<Icon icon="eye-off" />
    ) : null
);

HiddenPageIndicator.propTypes = {
    hiddenPage: PropTypes.bool,
};

export default HiddenPageIndicator;
